import React, { useCallback } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import { AssignmentTurnedIn } from '@mui/icons-material';

interface Props {
  defaultOption: boolean;
  style?: React.CSSProperties;
  onChange: (defaultOption: boolean) => void;
}

const DefaultOptionChooser: React.FC<Props> = ({ defaultOption, onChange, ...props }) => {
  const handleOnChange = useCallback(() => {
    onChange(!defaultOption);
  }, [onChange, defaultOption]);

  const color = defaultOption ? 'primary' : 'disabled';
  const tooltip = defaultOption ? 'Default Option' : 'Non-default Option';

  return (
    <Tooltip title={tooltip} placement="left">
      <IconButton aria-label="optional-mandatory" onClick={handleOnChange} {...props}>
        <AssignmentTurnedIn fontSize="small" color={color} />
      </IconButton>
    </Tooltip>
  );
};

export default DefaultOptionChooser;
